import React from 'react';
import { T } from '../../helpers/i18n';
import theme from '../../Theme';
import { toMoney } from '../../helpers/Format';
import { PaymentMethod } from '../../Models/TicketPayment';
export const RenderPayments = ({ item }) => {
    // console.log('renderPayments - payments: ', item.payments)
    if (item.payments && item.payments.length > 0) {
        /*if (item.payments.length === 1) {
          return (<p style={{ textDecoration: item.daterefund?'line-through': 'initial', margin: '0', padding: 0, textAlign: 'end', }}>
            {`${t(item.payments[0].method)}: ${item.payments[0].method === PaymentMethod.Credit? item.payments[0].afiliateName? item.payments[0].afiliateName: '' : ''}`}
          </p>)
        }*/
        return React.createElement("div", { style: { display: 'inline-block', border: `1px solid ${theme.color.secondary}`, padding: '1rem' } }, item.payments.filter(pago => pago.method !== PaymentMethod.Due).map(payment => React.createElement("div", { key: payment.method, style: {
                textDecoration: item.daterefund || (payment.method === PaymentMethod.Due && !item.totalDue) ? 'line-through' : 'inherit',
                backgroundColor: payment.method === PaymentMethod.Due && item.totalDue > 0 ? 'red' : 'inherit',
                color: payment.method === PaymentMethod.Due && item.totalDue > 0 ? 'white' : 'inherit',
            } }, `${T(payment.method)}: ${toMoney(payment.amount, item.money)} ${payment.method === PaymentMethod.Credit ? payment.afiliateName ? payment.afiliateName : '' : ''}`)));
    }
    else {
        return (React.createElement("p", { style: { textDecoration: item.daterefund ? 'line-through' : 'initial', margin: '0', padding: 0, textAlign: 'end', } }, `${T(item.tipoPago ? item.tipoPago : PaymentMethod.Cash)}`));
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Payments.tsx
// module id = 517
// module chunks = 0